import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { fetchAddressByZipCode, isCompleteZipCode, onlyDigits } from "../../helpers/address";

import PanelTemplate from "../../templates/Panel";
import PageFooter from "../../components/PageFooter";
import Button from "../../components/Button";
import ButtonDropdown from "../../components/ButtonDropdown";
import api from "../../services/api";
import { renderError } from "../../helpers/errors";

import { ModalDelete } from "../../components/ModalDelete";
import { Modal } from "../../components/Modal";
import BoxTabs from "../../components/BoxTabs";
import OrderDetailTab from "./tabs/detail";
import OrderNfsTab from "./tabs/nfs";
import OrderFinanceTab from "./tabs/finance";
import BankSlipTab from "./tabs/bankslips";
import { toast } from "react-toastify";
import Box from "../../components/Box";
import Table from "../../components/Table";
import { convertIntToMoney, convertMoenyToInt } from "../../helpers/conversions";
import ModalProductDetails from "./modals/ModalProductDetails";
import { FEATURE_COMING_SOON, FEATURE_ENABLED, GESTAO_FEATURE, GESTAO_PERMISSIONS, getGestaoState, hasPermission, hasPlanFeature } from "../../services/auth";
import { SoonPill } from "../../components/GestaoTeaser";
import { PlanFeatureUpgradeModal } from "../../components/PlanFeatureUpgradeModal";
import Spinner from "../../components/Spinner";
import { checkComissao, countProductPendingConferences, countProductPendingConferencesTag } from "./helpers/conference";
import LinkedRecords from "../../components/LinkedRecords";
import { emptyPayment, paymentFromResource, paymentPayload } from "../../components/PaymentCondition/helpers";
import { ORDER_CHAIN_LABELS, orderGestaoPlaceholders, orderLinksConfig, orderLinksItemTo } from "./links";
import PurchaseOrderModals from "../PurchaseOrder/PurchaseOrderModals";

export const OrderEdit = () => {
    const { id } = useParams();
    const navigete = useNavigate();
    const location = useLocation();

    const [loading, setLoading] = useState(false);
    const [order, setOrder] = useState(null);
    const [confirmDelete, setConfirmDelete] = useState(false);

    const [itemsData, setItemsData] = useState({ header: [], rows: [] });

    const [links, setLinks] = useState(null);
    const [linksLoading, setLinksLoading] = useState(true);

    const [purchaseOrderToShow, setPurchaseOrderToShow] = useState(null);
    const [purchaseOrdersVersion, setPurchaseOrdersVersion] = useState(0);

    const [selectedStatus, setSelectedStatus] = useState(null);
    const [selectedPagamentoStatus, setSelectedPagamentoStatus] = useState(null);
    const [selectedFaturadoStatus, setSelectedFaturadoStatus] = useState(null);
    const [financeComments, setFinanceComments] = useState('');

    const [shippingTypeReal, setShippingTypeReal] = useState(null);
    const [shippingFeeReal, setShippingFeeReal] = useState('R$ 0,00');
    const [shippingTimeReal, setShippingTimeReal] = useState('');
    const [shippingTime, setShippingTime] = useState('');
    const [paymentTermReal, setPaymentTermReal] = useState('');
    const [paymentFormReal, setPaymentFormReal] = useState('');
    const [tinyStatus, setTinyStatus] = useState(null);
    const [tinyError, setTinyError] = useState(null);
    const [showTinyErrorModal, setShowTinyErrorModal] = useState(false);
    const tinyPollingRef = useRef(null);
    const [billingCompanyCnpjReal, setBillingCompanyCnpjReal] = useState('');

    const [shippingTypeConference, setShippingTypeConference] = useState(false);
    const [shippingFeeConference, setShippingFeeConference] = useState(false);
    const [shippingTimeConference, setShippingTimeConference] = useState(false);
    const [paymentTermConference, setPaymentTermConference] = useState(false);
    const [paymentFormConference, setPaymentFormConference] = useState(false);
    const [billingCompanyCnpjConference, setBillingCompanyCnpjConference] = useState(false);

    const [itemToShowDetails, setItemToShowDetails] = useState(null);

    // Campos editáveis - Cliente
    const [customerCompanyCnpj, setCustomerCompanyCnpj] = useState('');
    const [customerCompanyCompanyName, setCustomerCompanyCompanyName] = useState('');
    const [customerCompanyTradeName, setCustomerCompanyTradeName] = useState('');
    const [customerCpf, setCustomerCpf] = useState('');
    const [customerName, setCustomerName] = useState('');
    const [customerEmail, setCustomerEmail] = useState('');
    const [customerPhone, setCustomerPhone] = useState('');

    // Campos editáveis - Empresa de faturamento
    const [billingCompanyCnpj, setBillingCompanyCnpj] = useState('');
    const [billingCompanyCompanyName, setBillingCompanyCompanyName] = useState('');
    const [billingCompanyTradeName, setBillingCompanyTradeName] = useState('');

    // Campos editáveis - Entrega
    const [shippingRecipientName, setShippingRecipientName] = useState('');
    const [shippingCompanyName, setShippingCompanyName] = useState('');

    // Campos editáveis - Endereço de entrega
    const [shippingZipCode, setShippingZipCode] = useState('');
    const [shippingStreet, setShippingStreet] = useState('');
    const [shippingNumber, setShippingNumber] = useState('');
    const [shippingComplement, setShippingComplement] = useState('');
    const [shippingDistrict, setShippingDistrict] = useState('');
    const [shippingCity, setShippingCity] = useState('');
    const [shippingState, setShippingState] = useState('');

    // Campos editáveis - Endereço de cobrança
    const [billingZipCode, setBillingZipCode] = useState('');
    const [billingStreet, setBillingStreet] = useState('');
    const [billingNumber, setBillingNumber] = useState('');
    const [billingComplement, setBillingComplement] = useState('');
    const [billingDistrict, setBillingDistrict] = useState('');
    const [billingCity, setBillingCity] = useState('');
    const [billingState, setBillingState] = useState('');

    // Campos editáveis - Endereço do cliente
    // Último CEP que já corresponde ao endereço em tela — venha do pedido
    // carregado ou de uma consulta anterior. É a trava que impede a consulta de
    // rodar no carregamento e de reescrever o endereço quando o usuário mexeu
    // em rua, bairro ou cidade sem trocar o CEP.
    const settledClientZipCode = useRef(null);
    const settledShippingZipCode = useRef(null);
    const settledBillingZipCode = useRef(null);

    // O que impede a emissão da nota é o dado gravado NO PEDIDO, não o do
    // cadastro do cliente. A aba de notas manda para cá o que está furado e a
    // aba Detalhes marca os campos — só depois do clique, porque quem abre o
    // pedido para outra coisa não tem nada a ver com a emissão.
    const [tab, setTab] = useState(0);
    const gestaoState = getGestaoState();
    const gestaoSoon = gestaoState === FEATURE_COMING_SOON;
    const showGestaoTeaser = gestaoState !== FEATURE_ENABLED && hasPermission(GESTAO_PERMISSIONS);
    const [showGestaoUpgrade, setShowGestaoUpgrade] = useState(false);
    const [fiscalFieldErrors, setFiscalFieldErrors] = useState({});

    /**
     * Guarda, junto da mensagem, o valor que estava errado quando a checagem
     * rodou. É o que faz o erro sumir sozinho: a marcação vale enquanto o
     * campo continuar com aquele valor. Preencher à mão limpa, e o endereço
     * trazido pelo CEP limpa junto, sem precisar consultar o backend de novo.
     */
    const applyFiscalErrors = problems => {
        const currentValues = {
            customer_cpf: customerCpf,
            customer_company_cnpj: customerCompanyCnpj,
            zip_code: clientZipCode,
            street: clientStreet,
            number: clientNumber,
            district: clientDistrict,
            city: clientCity,
            state: clientState,
        };

        const messages = {
            customer_document: 'Obrigatório para emitir a nota fiscal',
            customer_address: 'Obrigatório para emitir a nota fiscal',
            customer_zip_code: 'CEP não reconhecido',
        };

        const errors = {};

        (problems ?? []).forEach(problem => {
            (problem.fields ?? []).forEach(field => {
                if (errors[field]) return;

                errors[field] = {
                    message: messages[problem.field] ?? problem.message,
                    at: currentValues[field] ?? '',
                };
            });
        });

        setFiscalFieldErrors(errors);
        setTab(0);
    };

    const [clientZipCode, setClientZipCode] = useState('');
    const [clientStreet, setClientStreet] = useState('');
    const [clientNumber, setClientNumber] = useState('');
    const [clientComplement, setClientComplement] = useState('');
    const [clientDistrict, setClientDistrict] = useState('');
    const [clientCity, setClientCity] = useState('');
    const [clientState, setClientState] = useState('');

    // Campos editáveis - Pagamento
    const [payment, setPayment] = useState(emptyPayment);

    // Campos editáveis - Observações/Comentários
    const [comments, setComments] = useState('');

    useEffect(() => {
        getOrder();
        getLinks();
        return () => stopTinyPolling();
    }, []);

    /**
     * Preenche o endereço a partir do CEP, e **só quando o CEP muda de fato**.
     *
     * O pedido guarda um retrato do endereço no momento em que foi criado, e
     * esse retrato costuma estar ajustado à mão: CEP genérico de cidade que
     * alguém completou, rua que mudou de nome, complemento que o ViaCEP não
     * conhece. Consultar a cada render, ou ao carregar o pedido, jogaria tudo
     * isso fora — é o que acontece hoje no cadastro de cliente.
     *
     * Trocar o CEP é dizer "este endereço é outro", então aí sim os campos que
     * a consulta devolve são substituídos. Número e complemento nunca são
     * tocados: o ViaCEP não sabe deles.
     */
    const applyZipCodeLookup = async (zipCode, settled, setters) => {
        const digits = onlyDigits(zipCode);

        if (!isCompleteZipCode(digits) || digits === settled.current) return;

        settled.current = digits;

        const address = await fetchAddressByZipCode(digits);

        if (!address) return;

        if (address.street) setters.street(address.street);
        if (address.district) setters.district(address.district);
        if (address.city) setters.city(address.city);
        if (address.state) setters.state(address.state);
    };

    useEffect(() => {
        applyZipCodeLookup(clientZipCode, settledClientZipCode, {
            street: setClientStreet,
            district: setClientDistrict,
            city: setClientCity,
            state: setClientState,
        });
    }, [clientZipCode]);

    useEffect(() => {
        applyZipCodeLookup(shippingZipCode, settledShippingZipCode, {
            street: setShippingStreet,
            district: setShippingDistrict,
            city: setShippingCity,
            state: setShippingState,
        });
    }, [shippingZipCode]);

    useEffect(() => {
        applyZipCodeLookup(billingZipCode, settledBillingZipCode, {
            street: setBillingStreet,
            district: setBillingDistrict,
            city: setBillingCity,
            state: setBillingState,
        });
    }, [billingZipCode]);

    /**
     * Requisição própria, depois do pedido: a coluna de vínculos não pode
     * atrasar a tela, e erro nela não pode derrubá-la.
     */
    const getLinks = (silent = false) => {
        if (!silent) setLinksLoading(true);

        api.get(`/order/${id}/links`).then(res => {
            setLinks(res.data);
        }).catch(() => {
            if (!silent) setLinks(null);
        }).then(() => setLinksLoading(false));
    }

    const getOrder = () => {
        setLoading(true);

        api.get(`/order/${id}`).then(res => {
            let resource = res.data.resource;
            const type = resource.type;
            const normalizedType = (type === 'PJ' || type === 'PF')
                ? type
                : (Array.isArray(type) && type.includes('PJ'))
                    ? 'PJ'
                    : (Array.isArray(type) && type.includes('PF'))
                        ? 'PF'
                        : type?.[0] ?? type;
            setOrder({ ...resource, type: normalizedType });
            setSelectedStatus(resource.status_id);
            setSelectedPagamentoStatus(resource.pagamento_status);
            setSelectedFaturadoStatus(resource.faturado_status);
            setFinanceComments(resource.finance_comments);
            setShippingTypeReal(resource.shipping_type_real);
            setShippingTypeConference(resource.shipping_type_conference);
            setShippingFeeReal(convertIntToMoney(resource.shipping_fee_real, true));
            setShippingFeeConference(resource.shipping_fee_conference);
            setShippingTimeReal(resource.shipping_time_real);
            setShippingTime(resource.shipping_time ?? '');
            setShippingTimeConference(resource.shipping_time_conference);
            setPaymentTermReal(resource.payment_term_real);
            setPaymentTermConference(resource.payment_term_conference);
            setPaymentFormReal(resource.payment_form_real);
            setPaymentFormConference(resource.payment_form_conference);
            setBillingCompanyCnpjReal(resource.billing_company_cnpj_real);
            setBillingCompanyCnpjConference(resource.billing_company_cnpj_conference);
            setCustomerCompanyCnpj(resource.customer_company_cnpj ?? '');
            setCustomerCompanyCompanyName(resource.customer_company_company_name ?? '');
            setCustomerCompanyTradeName(resource.customer_company_trade_name ?? '');
            setCustomerCpf(resource.customer_cpf ?? '');
            setCustomerName(resource.customer_name ?? '');
            setCustomerEmail(resource.customer_email ?? '');
            setCustomerPhone(resource.customer_phone ?? '');
            setBillingCompanyCnpj(resource.billing_company_cnpj ?? '');
            setBillingCompanyCompanyName(resource.billing_company_company_name ?? '');
            setBillingCompanyTradeName(resource.billing_company_trade_name ?? '');
            setShippingRecipientName(resource.shipping_recipient_name ?? '');
            setShippingCompanyName(resource.shipping_company_trade_name ?? '');
            const shipAddr = resource.shipping_address || {};
            setShippingZipCode(shipAddr.zip_code ?? '');
            settledShippingZipCode.current = onlyDigits(shipAddr.zip_code);
            setShippingStreet(shipAddr.street ?? '');
            setShippingNumber(shipAddr.number ?? '');
            setShippingComplement(shipAddr.complement ?? '');
            setShippingDistrict(shipAddr.district ?? '');
            setShippingCity(shipAddr.city ?? '');
            setShippingState(shipAddr.state ?? '');
            const billAddr = resource.billing_address || {};
            setBillingZipCode(billAddr.zip_code ?? '');
            settledBillingZipCode.current = onlyDigits(billAddr.zip_code);
            setBillingStreet(billAddr.street ?? '');
            setBillingNumber(billAddr.number ?? '');
            setBillingComplement(billAddr.complement ?? '');
            setBillingDistrict(billAddr.district ?? '');
            setBillingCity(billAddr.city ?? '');
            setBillingState(billAddr.state ?? '');
            const clientAddr = resource.client_address || resource.customer_company_address || resource.customer_address || {};
            setClientZipCode(clientAddr.zip_code ?? '');
            settledClientZipCode.current = onlyDigits(clientAddr.zip_code);
            setClientStreet(clientAddr.street ?? '');
            setClientNumber(clientAddr.number ?? '');
            setClientComplement(clientAddr.complement ?? '');
            setClientDistrict(clientAddr.district ?? '');
            setClientCity(clientAddr.city ?? '');
            setClientState(clientAddr.state ?? '');
            setPayment(paymentFromResource(resource));
            setComments(resource.observations?.comments ?? resource.comments ?? '');
            getItems(resource.items);
            applyTinyStatus(resource.tiny_status, resource.tiny_error);
        }).catch(error => {
            renderError(error);
        }).then(() => setLoading(false));
    }

    const deleteOrder = () => {
        setLoading(true);

        api.delete(`/order/${id}`).then(res => {
            navigete(getOrderListReturnUrl());
        }).catch(error => {
            renderError(error);
            setLoading(false);
        });
    }

    const getOrderListReturnUrl = () => {
        const params = new URLSearchParams(location.search);
        const returnTo = params.get('return_to');

        return returnTo && returnTo.startsWith('/order/list') ? returnTo : '/order/list';
    }

    const updateOrder = () => {
        setLoading(true);

        const payload = {
            customer_type: order?.type ?? '',
            status_id: selectedStatus,
            shipping_time: shippingTime,
            customer_company_cnpj: customerCompanyCnpj ?? '',
            customer_company_company_name: customerCompanyCompanyName ?? '',
            customer_company_trade_name: customerCompanyTradeName ?? '',
            customer_cpf: customerCpf ?? '',
            customer_name: customerName ?? '',
            customer_email: customerEmail ?? '',
            customer_phone: customerPhone ?? '',
            billing_company_cnpj: billingCompanyCnpj ?? '',
            billing_company_company_name: billingCompanyCompanyName ?? '',
            billing_company_trade_name: billingCompanyTradeName ?? '',
            shipping_recipient_name: shippingRecipientName ?? '',
            shipping_company_trade_name: shippingCompanyName ?? '',
            shipping_address: {
                zip_code: shippingZipCode ?? '',
                street: shippingStreet ?? '',
                number: shippingNumber ?? '',
                complement: shippingComplement ?? '',
                district: shippingDistrict ?? '',
                city: shippingCity ?? '',
                state: shippingState ?? ''
            },
            billing_address: {
                zip_code: billingZipCode ?? '',
                street: billingStreet ?? '',
                number: billingNumber ?? '',
                complement: billingComplement ?? '',
                district: billingDistrict ?? '',
                city: billingCity ?? '',
                state: billingState ?? ''
            },
            client_address: {
                zip_code: clientZipCode ?? '',
                street: clientStreet ?? '',
                number: clientNumber ?? '',
                complement: clientComplement ?? '',
                district: clientDistrict ?? '',
                city: clientCity ?? '',
                state: clientState ?? ''
            },
            ...paymentPayload(payment),
            comments: comments ?? ''
        };

        api.put(`/order/${order.id}`, payload).then(res => {
            toast.success('Pedido atualizado com sucesso');
            getOrder();
            getLinks();
        }).catch(error => {
            renderError(error);
        }).then(() => setLoading(false));
    }

    const getItems = items => {
        let header = ['Imagem', 'SKU', 'Nome', 'Quant.', 'Preço unit.', 'Total'];
        const rows = [];

        // if(hasPermission('view_margem_order')){
        //     header.push('Margem orçamento');
        //     header.push('Margem real');
        // }

        // header.push('Comissão');
        // header.push('Conferência');

        items.map(item => {

            let image = <img src={item.product_mock_image_url ?? item.subproduct_image_url.small} />;

            let data = [
                image,
                item.subproduct_sku,
                item.product_name,
                item.quantity,
                `R$${convertIntToMoney(item.price)}`,
                `R$${convertIntToMoney(item.price * item.quantity)}`
            ];

            // if(hasPermission('view_margem_order')){
            //     data.push(`R$${convertIntToMoney(item.margem_orcamento)}`);
            //     data.push(`R$${convertIntToMoney(item.margem_real)}`);
            // }

            // data.push(checkComissao(item));
            // data.push(countProductPendingConferencesTag(item));

            rows.push({
                data,
                // action: () => console.log(item)
                // action: () => setItemToShowDetails(item)
            });
        });

        setItemsData({ header, rows });
    }

    const sendOrder = () => {
        setLoading(true);

        api.post(`/order/${order.id}/send`).then(res => {
            toast.success('Pedido enviado com sucesso');
        }).catch(error => {
            renderError(error);
        }).then(() => setLoading(false));
    }

    const applyTinyStatus = (status, error) => {
        console.log('applyTinyStatus', status, error);
        setTinyStatus(status);
        setTinyError(error);
        if (status === 'queued') {
            startTinyPolling();
        } else {
            stopTinyPolling();
        }
    }

    const startTinyPolling = () => {
        stopTinyPolling();
        tinyPollingRef.current = setInterval(() => {
            api.get(`/order/${id}/tiny/status`).then(res => {
                const { tiny_status, tiny_error } = res.data;
                setTinyStatus(tiny_status);
                setTinyError(tiny_error);
                if (tiny_status !== 'queued') {
                    stopTinyPolling();
                }
            }).catch(() => stopTinyPolling());
        }, 5000);
    }

    const stopTinyPolling = () => {
        if (tinyPollingRef.current) {
            clearInterval(tinyPollingRef.current);
            tinyPollingRef.current = null;
        }
    }

    const sendOrderToTiny = () => {
        setLoading(true);
        setTinyStatus('queued');
        api.post(`/order/${order.id}/tiny`).then(res => {
            const { tiny_status, tiny_error } = res.data.resource;
            applyTinyStatus(tiny_status, tiny_error);
            toast.success('Pedido enviado para o Tiny com sucesso');
        }).catch(error => {
            setTinyStatus(null);
            renderError(error);
        }).then(() => setLoading(false));
    }

    const getTinyButtonText = () => {
        if (tinyStatus === 'sent') return 'Pedido enviado para o Tiny';
        if (tinyStatus === 'queued') return <><Spinner style={{ marginRight: 6 }} />Enviando para o Tiny...</>;
        if (tinyStatus === 'failed') return 'Falhou - Reenviar para o Tiny';
        return 'Enviar pedido para o Tiny';
    }

    const refreshPurchaseOrders = () => {
        getLinks();
        setPurchaseOrdersVersion(version => version + 1);
    };

    return (
        <>
            <PurchaseOrderModals
                purchaseOrder={purchaseOrderToShow}
                close={() => setPurchaseOrderToShow(null)}
                onChanged={refreshPurchaseOrders}
            />
            {itemToShowDetails &&
                <ModalProductDetails
                    close={() => setItemToShowDetails(null)}
                    item={itemToShowDetails}
                    getOrder={getOrder}
                />
            }
            <Modal
                show={showTinyErrorModal}
                close={() => setShowTinyErrorModal(false)}
                title="Erro ao enviar para o Tiny"
                footer={
                    <>
                        <Button type={`primary`} size={`small`} text={`Reenviar`} action={() => { setShowTinyErrorModal(false); sendOrderToTiny(); }} loading={loading} />
                        <Button type={`secondary`} size={`small`} text={`Fechar`} action={() => setShowTinyErrorModal(false)} />
                    </>
                }
            >
                <p>{tinyError || 'Ocorreu um erro ao enviar o pedido para o Tiny.'}</p>
            </Modal>
            <ModalDelete
                show={confirmDelete}
                action={deleteOrder}
                loading={loading}
                close={() => setConfirmDelete(false)}
            />
            <PlanFeatureUpgradeModal
                feature={GESTAO_FEATURE}
                show={showGestaoUpgrade}
                close={() => setShowGestaoUpgrade(false)}
            />
            <PanelTemplate id="order-edit">
                <div className="linked-layout">
                    <div className="linked-layout-main">
                        <BoxTabs
                            tab={tab}
                            setTab={setTab}
                            titles={[
                                'Detalhes',
                                <>Notas fiscais{gestaoSoon && <SoonPill />}</>,
                                <>Financeiro e compras{gestaoSoon && <SoonPill />}</>,
                                'Boletos'
                            ]}
                            contents={
                                [
                                    <OrderDetailTab
                                        order={order}
                                        fiscalFieldErrors={fiscalFieldErrors}
                                        selectedStatus={selectedStatus}
                                        setSelectedStatus={setSelectedStatus}
                                        selectedPagamentoStatus={selectedPagamentoStatus}
                                        setSelectedPagamentoStatus={setSelectedPagamentoStatus}
                                        selectedFaturadoStatus={selectedFaturadoStatus}
                                        setSelectedFaturadoStatus={setSelectedFaturadoStatus}
                                        financeComments={financeComments}
                                        setFinanceComments={setFinanceComments}
                                        shippingTypeReal={shippingTypeReal}
                                        setShippingTypeReal={setShippingTypeReal}
                                        shippingFeeReal={shippingFeeReal}
                                        setShippingFeeReal={setShippingFeeReal}
                                        shippingTimeReal={shippingTimeReal}
                                        setShippingTimeReal={setShippingTimeReal}
                                        shippingTime={shippingTime}
                                        setShippingTime={setShippingTime}
                                        paymentTermReal={paymentTermReal}
                                        setPaymentTermReal={setPaymentTermReal}
                                        paymentFormReal={paymentFormReal}
                                        setPaymentFormReal={setPaymentFormReal}
                                        shippingTypeConference={shippingTypeConference}
                                        setShippingTypeConference={setShippingTypeConference}
                                        shippingFeeConference={shippingFeeConference}
                                        setShippingFeeConference={setShippingFeeConference}
                                        shippingTimeConference={shippingTimeConference}
                                        setShippingTimeConference={setShippingTimeConference}
                                        paymentTermConference={paymentTermConference}
                                        setPaymentTermConference={setPaymentTermConference}
                                        paymentFormConference={paymentFormConference}
                                        setPaymentFormConference={setPaymentFormConference}
                                        billingCompanyCnpjReal={billingCompanyCnpjReal}
                                        setBillingCompanyCnpjReal={setBillingCompanyCnpjReal}
                                        billingCompanyCnpjConference={billingCompanyCnpjConference}
                                        setBillingCompanyCnpjConference={setBillingCompanyCnpjConference}
                                        customerCompanyCnpj={customerCompanyCnpj}
                                        setCustomerCompanyCnpj={setCustomerCompanyCnpj}
                                        customerCompanyCompanyName={customerCompanyCompanyName}
                                        setCustomerCompanyCompanyName={setCustomerCompanyCompanyName}
                                        customerCompanyTradeName={customerCompanyTradeName}
                                        setCustomerCompanyTradeName={setCustomerCompanyTradeName}
                                        customerCpf={customerCpf}
                                        setCustomerCpf={setCustomerCpf}
                                        customerName={customerName}
                                        setCustomerName={setCustomerName}
                                        customerEmail={customerEmail}
                                        setCustomerEmail={setCustomerEmail}
                                        customerPhone={customerPhone}
                                        setCustomerPhone={setCustomerPhone}
                                        billingCompanyCnpj={billingCompanyCnpj}
                                        setBillingCompanyCnpj={setBillingCompanyCnpj}
                                        billingCompanyCompanyName={billingCompanyCompanyName}
                                        setBillingCompanyCompanyName={setBillingCompanyCompanyName}
                                        billingCompanyTradeName={billingCompanyTradeName}
                                        setBillingCompanyTradeName={setBillingCompanyTradeName}
                                        shippingRecipientName={shippingRecipientName}
                                        setShippingRecipientName={setShippingRecipientName}
                                        shippingCompanyName={shippingCompanyName}
                                        setShippingCompanyName={setShippingCompanyName}
                                        shippingZipCode={shippingZipCode}
                                        setShippingZipCode={setShippingZipCode}
                                        shippingStreet={shippingStreet}
                                        setShippingStreet={setShippingStreet}
                                        shippingNumber={shippingNumber}
                                        setShippingNumber={setShippingNumber}
                                        shippingComplement={shippingComplement}
                                        setShippingComplement={setShippingComplement}
                                        shippingDistrict={shippingDistrict}
                                        setShippingDistrict={setShippingDistrict}
                                        shippingCity={shippingCity}
                                        setShippingCity={setShippingCity}
                                        shippingState={shippingState}
                                        setShippingState={setShippingState}
                                        billingZipCode={billingZipCode}
                                        setBillingZipCode={setBillingZipCode}
                                        billingStreet={billingStreet}
                                        setBillingStreet={setBillingStreet}
                                        billingNumber={billingNumber}
                                        setBillingNumber={setBillingNumber}
                                        billingComplement={billingComplement}
                                        setBillingComplement={setBillingComplement}
                                        billingDistrict={billingDistrict}
                                        setBillingDistrict={setBillingDistrict}
                                        billingCity={billingCity}
                                        setBillingCity={setBillingCity}
                                        billingState={billingState}
                                        setBillingState={setBillingState}
                                        clientZipCode={clientZipCode}
                                        setClientZipCode={setClientZipCode}
                                        clientStreet={clientStreet}
                                        setClientStreet={setClientStreet}
                                        clientNumber={clientNumber}
                                        setClientNumber={setClientNumber}
                                        clientComplement={clientComplement}
                                        setClientComplement={setClientComplement}
                                        clientDistrict={clientDistrict}
                                        setClientDistrict={setClientDistrict}
                                        clientCity={clientCity}
                                        setClientCity={setClientCity}
                                        clientState={clientState}
                                        setClientState={setClientState}
                                        payment={payment}
                                        setPayment={setPayment}
                                        comments={comments}
                                        setComments={setComments}
                                    />,
                                    order && <OrderNfsTab
                                        order={order}
                                        onFixFields={applyFiscalErrors}
                                        onDocumentsChanged={() => getLinks(true)}
                                    />,
                                    order && <OrderFinanceTab
                                        order={order}
                                        purchaseOrdersVersion={purchaseOrdersVersion}
                                        onOpenPurchaseOrder={setPurchaseOrderToShow}
                                        onPurchaseOrdersGenerated={getLinks}
                                    />,
                                    order && <BankSlipTab
                                        order={order}
                                    />
                                ]
                            }
                        />
                        <Box
                            className={`no-padding`}
                            title={`Produtos do pedido`}
                        >
                            <Table header={itemsData.header} rows={itemsData.rows} loading={loading} />
                        </Box>
                        <PageFooter spaceBetween={true}>
                            <div>
                                {hasPermission('edit_order') &&
                                    <Button type={`primary`} size={`small`} svg={`save-white`} text={`Salvar alterações`} action={updateOrder} loading={loading} />
                                }
                                <ButtonDropdown
                                    type={`secondary`}
                                    size={`small`}
                                    leadingSvg={`pdf`}
                                    text={`Gerar PDF do pedido`}
                                    loading={loading}
                                    dropUp
                                    matchWidth
                                    actions={[
                                        {
                                            text: 'Completo com valores',
                                            svg: 'money',
                                            action: () => window.open(order?.pdf_url)
                                        },
                                        {
                                            text: 'Com valores ocultos',
                                            svg: 'eyeoff',
                                            action: () => window.open(`${order?.pdf_url}&hide_values=1`)
                                        }
                                    ]}
                                />
                                {hasPermission('send_order') &&
                                    <Button type={`secondary`} size={`small`} svg={`send`} text={`Enviar pedido`} action={sendOrder} loading={loading} />
                                }
                                {hasPlanFeature('integration_tiny') && hasPermission('edit_order') &&
                                    <Button
                                        type={`secondary`}
                                        size={`small`}
                                        text={getTinyButtonText()}
                                        action={
                                            tinyStatus === 'failed' ? () => setShowTinyErrorModal(true) :
                                            tinyStatus === 'queued' ? () => toast.info('O pedido está sendo enviado. Esse processo pode levar alguns minutos.') :
                                            tinyStatus === 'sent' ? undefined :
                                            sendOrderToTiny
                                        }
                                        loading={loading}
                                        disabled={tinyStatus === 'sent'}
                                    />
                                }
                            </div>
                            <div>
                                {hasPermission('delete_order') &&
                                    <Button type={`secondary`} size={`small`} loading={loading} text={`Excluir`} svg={`delete-small`} action={() => setConfirmDelete(true)} />
                                }
                            </div>
                        </PageFooter>
                    </div>
                    <LinkedRecords
                        loading={linksLoading}
                        chainTitle={`Cadeia do pedido`}
                        chain={links?.chain ?? []}
                        chainLabels={ORDER_CHAIN_LABELS}
                        groups={links?.groups ?? []}
                        config={orderLinksConfig(order)}
                        itemTo={orderLinksItemTo(order, setPurchaseOrderToShow)}
                        storageKey={`order.links.collapsed`}
                        placeholders={showGestaoTeaser ? orderGestaoPlaceholders(gestaoSoon ? null : () => setShowGestaoUpgrade(true)) : []}
                        placeholdersBefore={`bankslips`}
                    />
                </div>
            </PanelTemplate>
        </>
    );
}

export default OrderEdit;
